// extracted by mini-css-extract-plugin
module.exports =  {"graph":"ChangesGraph__graph--DW"};